import React, { useState, useEffect, useCallback, FunctionComponent, useRef } from 'react';
import { Presentation } from './presentation';
import { sendResetEmail } from '../../../services/passwordResets';
import { getCsrfToken } from '../../../libs/csrfToken';
import { useFlash } from '../../../hooks/useFlash';

type Props = {
  defaultEmail?: string;
};

export const Component: FunctionComponent<Props> = ({ defaultEmail = '' }) => {
  const [email, setEmail] = useState(defaultEmail);
  const [isLoading, setIsLoading] = useState(false);
  const { flash, flashType, flashMessage, handleFlash } = useFlash();

  const handleChangeEmail = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setEmail(e.target.value);
    },
    []
  );

  const handleSubmitResetEmail = async () => {
    try {
      setIsLoading(true);
      handleFlash(false, '', '');
      const response = await sendResetEmail(JSON.stringify({ email: email }), getCsrfToken());
      handleFlash(response.flash, response.flashType, response.flashMessage);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Presentation
      email={email}
      isLoading={isLoading}
      flash={flash}
      flashType={flashType}
      flashMessage={flashMessage}
      handleFlash={handleFlash}
      onChangeEmail={handleChangeEmail}
      onSubmitPasswordReset={handleSubmitResetEmail}
    />
  );
};
